﻿/*global
$,
document,
com,
window,
setTimeout,
app_router,
unescape,
protectedPageExample,
console,
globalVersion,
navigator,
localStorage,
GEC,
serverData,
ga,
grecaptcha,
menuDataFallback_Test,
menuDataFallback_Prod,
modules,
commonSiteModule
*/

var GEC = gec;
let myGEC;

var gec = null,
    loginFrame,
    GBEUtils = com.globalbettingexchange.base,
    weHaveAlreadyJumpedMainContentDivToLeft = false,
    openToteboardPopups = [],
    isContestAccount = false,
    balanceSubscriber;

const GAP_BETWEEN_ELEMENTS = 6;

$(window).load(function () {

    "use strict";

    $(".partner-otherpage-link").click(function () {

        loginFrame = $("#loginFrame")[0].contentWindow;
        loginFrame.call("showDefaultContent");
        loginFrame.call("gepSession.recordInteraction");

    });

    $("#EJStemplates").html(window.frames.toteboardTemplatesFrame.document.getElementById("EJStemplates").innerHTML);

    initGoogleAnalytics();

    deleteSessionCookieUsedByClassicSite();

    if (serverData.promosAPIEnable && isNoDeepLinkInURL() && !isNewStyleContestAccount()) {

        // Site has been loaded with no deeplink, so we will display promo carousel

        if (!sessionStorage.sessionToken) {
            // User is not already logged in, so display promo carousel immediately (otherwise wait until user is logged in, then display logged in carousel)
            modules.renderPromoCarousel(document.getElementById("promoCarousel"), serverData.promosAPIURL, false, serverData.promosAPICachePeriodInSeconds, function () {
                initHeaderAndFooter();
            });
        }
    } else {
        initHeaderAndFooter();
    }

});

function initHeaderAndFooter() {
    "use strict";

    centreAndDisplayMainPanel();
    populateHeaderAndFooterFromAPI();
}

function isNoDeepLinkInURL() {
    "use strict";

    return (window.location.pathname === serverData.applicationPath ||
        window.location.pathname === serverData.applicationPath + "/");
}

function centreAndDisplayMainPanel() {
    "use strict";

    const windowWidth = $(window).width();
    const mainPanelWidth = $(".draggableMainPanel").width();
    const leftPos = (windowWidth - mainPanelWidth) / 2;
    $(".draggableMainPanel").css("left", `${leftPos}px`);
    $(".draggableOuter").css("visibility", "visible");
}

function showPromoCarousel() {
    "use strict";

    $("#promoCarousel").show();
}

function hidePromoCarousel() {
    "use strict";

    $("#promoCarousel").hide();
}

function isPromoCarouselVisible() {
    "use strict";

    return $("#promoCarousel").is(":visible");
}

function menuDataFallback() {
    "use strict";

    if (serverData.menuAPIURL.indexOf(".ft-nyrabets.com") > -1) {
        return menuDataFallback_Test;
    }
    return menuDataFallback_Prod;
}

let menuData;

function populateHeaderAndFooterFromAPI() {
    "use strict";

    if (sessionStorage.menuData) {
        const nowTimestamp = (new Date()).getTime();

        if (nowTimestamp < Number(sessionStorage.menuDataTimestamp) + (serverData.menuAPICachePeriodInSeconds * 1000)) {
            console.log(`menu cache is < ${serverData.menuAPICachePeriodInSeconds} seconds old, use it!`);
            menuData = JSON.parse(sessionStorage.menuData);
            renderHeaderAndFooterMenus(menuData);
            return;
        }
        console.log(`menu cache is > ${serverData.menuAPICachePeriodInSeconds} seconds old, ignore it and make fresh API call`);
    }

    const timeout = setTimeout(function () {
        renderHeaderAndFooterMenus(menuDataFallback());
    }, 3000);

    $.get(serverData.menuAPIURL, function(dataFromAPI) {
        menuData = dataFromAPI;
    }).fail(function(xhr, status, error) {
        console.error("Error getting menu JSON from " + serverData.menuAPIURL);
        console.error("Status: " + status);
        console.error("Error: " + error);
        menuData = menuDataFallback();
    }).always(function () {
        if (serverData.menuAPICachePeriodInSeconds > 0) {
            sessionStorage.menuData = JSON.stringify(menuData);
            sessionStorage.menuDataTimestamp = (new Date()).getTime();
        }
        clearTimeout(timeout);
        renderHeaderAndFooterMenus(menuData);
    });
}

function renderHeaderAndFooterMenus(menuDataToRender) {
    "use strict";

    try {
        modules.renderTopMenu(document.getElementById("topMenu"), menuDataToRender, "Bet");
    } catch (ex) {
        console.error("Error rendering top menu from API data");
        console.error(ex);
        console.error("Rendering static fallback menu instead...");
        modules.renderTopMenu(document.getElementById("topMenu"), menuDataFallback(), "Bet");
    }

    try {
        modules.renderFooterMenu(document.getElementById("footerMenu"), menuDataToRender);
    } catch (ex) {
        console.error("Error rendering footer menus from API data");
        console.error(ex);
        console.error("Rendering static fallback menu instead...");
        modules.renderFooterMenu(document.getElementById("footerMenu"), menuDataFallback());
    }

}

function setTopMenuCurrentlySelectedMenuLabel(currentlySelectedMenuLabel) {
    "use strict";

    modules.setTopMenuCurrentlySelectedMenuLabel(document.getElementById("topMenu"), currentlySelectedMenuLabel);
}

function getAboutContestUrlFromMenuData() {
    "use strict";

    let aboutContestsUrl = "https://racing.nyrabets.com/contests"; // fallback URL
    try {
        // Get URL from Contests item in main desktop menu (we assume it is always there)
        menuData.filter((menu) => menu.api_slug === "main").forEach(function (menu) {
            menu.items.filter((item) => item.value.key === "contests").forEach(function (item) {
                aboutContestsUrl = item.value.link;
            });
        });
    } catch (ex) {
        console.error("Error parsing menu data");
        console.error(ex);
    }
    return aboutContestsUrl;
}

function deleteUserSpecificCookiesSharedWithMarketingSite() {
    "use strict";

    try {
        $('#loginFrame')[0].contentWindow.deleteUserSpecificCookiesSharedWithMarketingSite();
    } catch (error) {
        // Login iframe probably not loaded yet - try again after a short delay
        setTimeout(function () {
            deleteUserSpecificCookiesSharedWithMarketingSite();
        }, 50);
    }
}

function initGoogleAnalytics() {
    "use strict";

    if (serverData.googleAnalyticsEnable) {
        /* eslint-disable */
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
        /* eslint-enable */

        ga('create', serverData.googleAnalyticsTrackingId, 'auto');
        ga('send', 'pageview');
    }
}


function setIsContestAccount(isContest) {
    "use strict";

    isContestAccount = isContest;
}

function getIsContestAccount() {
    "use strict";

    return isContestAccount;
}

function allowDraggingOfMainSiteContent() {
    "use strict";

    const windowWidth = $(window).width();
    const mainPanelWidth = $(".draggableMainPanel").width();
    const leftPos = (windowWidth - mainPanelWidth) / 2;
    $(".draggableMainPanel").css("left", `${leftPos}px`);
    $(".draggableMainPanel").draggable({
        containment: ".draggableOuter",
        //handle: ".dragMainDivIconNew",
        axis: "x",
        cursor: "ew-resize",
        iframeFix: true
    });

}

$(document).ready(function () {

    "use strict";

    // On hovering over a main menu item, display subitems
    $('ul.navbar li').mouseenter(function () {
        $(this).children('ul.subnav').show();
        $(this).children('a').addClass("selected");
    });

    // On leaving a main menu item, or its sub-items, hide the sub-item list
    $('ul.navbar li').mouseleave(function () {
        $(this).children('ul.subnav').hide();
        $(this).children('a').removeClass("selected");
    });

    // On clicking a main menu item or sub-item, hide all sub-items
    $('ul.navbar a').click(function () {
        $('ul.subnav').hide();
        $(this).removeClass("selected");
    });
});


function onTimingOut() {

    "use strict";

    return undefined;

}

function callGEPFunction(functionName, param1, param2, param3, param4, param5, param6, param7) {

    "use strict";

    try {
        $("#loginFrame")[0].contentWindow.call(functionName, param1, param2, param3, param4, param5, param6, param7);
    } catch (error) {
        setTimeout(function () {
            callGEPFunction(functionName, param1, param2, param3, param4, param5, param6, param7);
        }, 50);
    }
}

/** Change the route as specified, bringing the user to the relevant page
 *  Useful for pages for which we don't support deep-linking
 */
function routeChangeFunction(route) {
    "use strict";

    app_router.navigate(route, true);
}

function switchSiteLogoToContestLogo(entryName) {
    "use strict";

    if (entryName !== "") {
        $(".contestEntryName").text(entryName);
        $(".contestEntryNameOuter").show();
    }
}

function notifyContestUserLoggedIn(entryName) {
    "use strict";

    switchSiteLogoToContestLogo(entryName);
}

/** Change the fragmentId in the URL as specified, but do NOT change page */
function changeFragmentIdFunction(route) {
    "use strict";

    app_router.navigate(route, {
        trigger: false,
        replace: true
    });
}

function sameSiteValueForCookies() {
    "use strict";

    if (serverData.setSameSiteNoneOnCookies) {
        return "None";
    }
    return undefined;
}

function deleteSessionCookieUsedByClassicSite() {
    "use strict";

    GBEUtils.deleteCookie("sessionToken");
}

function createSessionCookieUsedByClassicSite() {
    "use strict";

    GBEUtils.setCookie("sessionToken", unescape("dummyTabGuid~" + gec.getSession()), undefined, sameSiteValueForCookies());
}

function goToClassicSite() {
    "use strict";

    createSessionCookieUsedByClassicSite();
    window.location.href = serverData.classicSiteUrl;
}

function isNewStyleContestAccount() {
    "use strict";

    return isContestAccount || sessionStorage.contestSession || window.location.href.indexOf("contestAccount=") !== -1;
}

function determineWhetherToShowPromoCarousel() {
    "use strict";

    if (serverData.promosAPIEnable && !isNewStyleContestAccount()) {
        if (sessionStorage.sessionToken) {
            // User loaded site already logged in
            // Whether or not we show the carousel depends on whether there's a deeplink or not
            if (isNoDeepLinkInURL()) {
                renderLoggedInPromoCarousel();
            }
        } else {
            // User has just logged in
            // If carousel currently shown, then update it to show only promos relevant for logged in users
            if (isPromoCarouselVisible()) {
                renderLoggedInPromoCarousel();
            }
        }
    }

}

function renderLoggedInPromoCarousel() {
    "use strict";

    modules.renderPromoCarousel(document.getElementById("promoCarousel"), serverData.promosAPIURL, true, serverData.promosAPICachePeriodInSeconds, function () {
        initHeaderAndFooter();
    });
}

function loggedInFunction() {

    "use strict";

    determineWhetherToShowPromoCarousel();

    gec = $("#loginFrame")[0].contentWindow.getGEC();

    const session = gec.getSession();

    $("#myAccount").show();

    if (isContestAccount) {
        try {
            sessionStorage.contestSession = unescape(session);
        } catch (ignore) {
            console.error("Error setting sessionStorage.contestSession"); // (this can happen in Safari Private Browing mode)
        }
    } else {
        try {
            sessionStorage.sessionToken = session;
        } catch (ex) {
            console.warn(ex);
        }
    }

    if (gec.getUserContext() !== null) {
        if (gec.getUserContext().cohort !== undefined
            && gec.getUserContext().cohort !== null) {
            GBEUtils.setCookie("cohort", unescape(gec.getUserContext().cohort), 999999, sameSiteValueForCookies());
        }

        if (gec.getUserContext().wageringCohort !== undefined
            && gec.getUserContext().wageringCohort !== null) {
            GBEUtils.setCookie("wageringCohort", unescape(gec.getUserContext().wageringCohort), 999999, sameSiteValueForCookies());
        } else if (gec.getUserContext().cohort !== undefined
            && gec.getUserContext().cohort !== null) {
            GBEUtils.setCookie("wageringCohort", unescape(gec.getUserContext().cohort), 999999, sameSiteValueForCookies());
        }
    }

    if (protectedPageExample !== null) {
        window.location = protectedPageExample;
    }

}

//called by the login iframe when user clicks Sing Out or session expired - delete any cookies and refresh page here
function loggedOutFunction(userInitiated) {

    "use strict";

    $("#myAccount").hide();

    if (isContestAccount) {
        try {
            delete sessionStorage.contestSession;
            delete sessionStorage.contestEntryName;
        } catch (ignore) {
            console.error("Exception deleting sessionStorage items");
        }
    } else {
        try {
            delete sessionStorage.sessionToken;
        } catch (ex) {
            console.warn(ex);
        }
    }

    GBEUtils.deleteCookie("hideBalance-NYRAPlus");

    // If deeplinked to page that requires login, remove deeplink hash from URL
    if (window.location.href.indexOf("deposit") > -1) {
        changeFragmentIdFunction("");
    }

    if (userInitiated) {
        window.location.reload(true);

    } else {
        window.location = "../";
    }
}

// eslint-disable-next-line vars-on-top
var protectedPageExample = null;

// Set the height of the footer iframe to be the same height as the content within it
function setFooterHeight() {

    "use strict";

    // Do in try/catch in case footer content is on different domain or not yet loaded
    try {
        $(".footerIframe").height(
            $(".footerIframe").contents().find("body").prop("scrollHeight")
        );
    } catch (ignore) {
        // ignore error
    }
}

function loginPanelAndGEPLoaded() {

    "use strict";

    // eslint-disable-next-line no-shadow
    var loginFrame;

    $("#loginstatusPanel").show();
    loginFrame = $("#loginFrame")[0].contentWindow;
    gec = loginFrame.getGEC();

    if ((protectedPageExample !== null) && (gec.getSession() === null)) {
        $("#fragment").show();
        loginFrame.call("requiresLogin", "This area requires log in!");
    }

    // GEP has loaded, so now safe to show the footer
    if ($("#fragment").is(":visible")) {

        $(".footer").show();

        // Re-do setting of footer height because...
        // Height should have been set on load of the footer, but while the footer has "display:none"
        // some browsers (IE, Firefox) return the height as 0! So have to re-do setting of the height
        // after showing the footer, to accommodate those browsers.
        setFooterHeight();
    }
}

function activateFunction() {
    "use strict";

    return undefined;
}

function maskHeader() {
    "use strict";

    $(".header-mask").show();

    const promoCarouselHeight = $("#promoCarousel").is(":visible") ? $("#promoCarousel").height() : 0;
    $(".header-mask").height($(".header.headermenu-from-api").height() + promoCarouselHeight);
}

function unmaskHeader() {
    "use strict";

    $(".header-mask").hide();
}

// Check if site is hosted within an iframe
function isSiteInIframe() {

    "use strict";

    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}


function showPushReconnectingMessage() {
    "use strict";

    $(".pushConnectionStatus .reconnecting").show();
}

function showPushConnectionReestablishedMessage() {
    "use strict";

    $(".pushConnectionStatus .reconnecting").hide();
    $(".pushConnectionStatus .reestablished").show();
    setTimeout(function () {
        $(".pushConnectionStatus .reestablished").hide();
    }, 2000);
}

const toteboardPopups = (function () {
    "use strict";

    const popupArray = [];

    const POPUP_HEADER_HEIGHT = 23;

    let popupPreferredWidth;
    let popupPreferredHeight;

    function init(maxNumberOfOpenPopups) {

        // Make sure not already initialised
        if (popupArray.length === maxNumberOfOpenPopups) {
            return;
        }

        for (let i = 0; i < maxNumberOfOpenPopups; i = i + 1) {
            // Each element in the array consists of { popup, position } so we can keep track of positions of
            // popups that have been closed, so next time the user opens a popup, it can be opened in the same place
            popupArray.push({
                popup: undefined,
                position: undefined
            });
        }
    }

    function addPopupToArray(popupToAdd) {
        // Add to first available slot
        $.each(popupArray, function (index, popup) {
            if (popup.popup === undefined) {
                popupArray[index] = {
                    popup: popupToAdd,
                    position: getPositionOfPopup(popupToAdd)
                };
                return false;   // exit $.each loop
            }
        });
    }

    function removePopupFromArray(popupToRemove) {
        // Remove popup from array, but leave position set
        $.each(popupArray, function (index, popup) {
            if (popup.popup === popupToRemove) {
                popupArray[index].popup = undefined;
                return false;   // exit $.each loop
            }
        });
    }

    function getCount() {
        const countNonUndefinedPopups = (total, element) => (element.popup !== undefined ? total + 1 : total);
        return popupArray.reduce(countNonUndefinedPopups, 0);
    }

    function getPositionOfPopup(popup) {
        if (popup === undefined) {
            return undefined;
        }
        return {
            top: $(popup).offset().top - POPUP_HEADER_HEIGHT,
            left: $(popup).offset().left
        };
    }

    function updatePopupPositions() {
        $.each(popupArray, function (index, popup) {
            if (popup.popup) {
                popup.position = getPositionOfPopup(popup.popup);
            }
        });
    }

    function sortPopupArrayFromTopToBottomOfDocument(popupsToSort) {
        popupsToSort.sort(function (a, b) {
            if (a.position !== undefined && b.position === undefined) {
                return -1;
            }
            if (a.position === undefined && b.position !== undefined) {
                return 1;
            }
            if (a.position === undefined && b.position === undefined) {
                return 0;
            }
            return a.position.top - b.position.top;
        });
    }

    function getPopupPositions() {
        // Return positions of all open popups, sorted from top to bottom on screen
        updatePopupPositions();
        sortPopupArrayFromTopToBottomOfDocument(popupArray);
        return popupArray.map((popup) => (
            popup.position === undefined ? undefined : popup.position
        ));
    }

    function getPreferredPositionToUse(preferredPositions) {
        let preferredPositionToUse;
        $.each(popupArray, function (index, popup) {
            if (popup.popup === undefined
                && preferredPositions.length > index
                && preferredPositions[index] !== undefined
                && preferredPositions[index] !== null) {

                preferredPositionToUse = preferredPositions[index];
                return false;   // exit $.each loop
            }
        });
        return preferredPositionToUse;
    }

    function getPopupFurthestDownThePage() {
        let cloneOfPopupArray = popupArray.slice(0);
        cloneOfPopupArray = cloneOfPopupArray.filter((popup) => popup.popup !== undefined);
        sortPopupArrayFromTopToBottomOfDocument(cloneOfPopupArray);
        if (cloneOfPopupArray.length > 0) {
            return $(cloneOfPopupArray[cloneOfPopupArray.length - 1].popup);
        }
        return undefined;
    }

    function getDefaultPopupPosition(popupWidth, popupHeight) {

        const widthOfMainDiv = $(".bodyWrapper").width();
        const xPosOfRightEdgeOfMainDiv = $(".bodyWrapper").offset().left + widthOfMainDiv;
        const yPosOfTopEdgeOfMainDiv = $(".bodyWrapper").offset().top + $(".header").height();
        const documentWidth = $(document).width();
        const documentHeight = $(document).height();

        if (getCount() === 0) {

            // No popups current exist

            // If there is sufficient space on page to right of main div,
            // position popup just to the right of main div
            if (xPosOfRightEdgeOfMainDiv + GAP_BETWEEN_ELEMENTS + popupWidth + GAP_BETWEEN_ELEMENTS
                < documentWidth) {

                // X position: position it horizontally immediately right of the main content frame
                // Y position: position it vertically in line with the top of the main content frame
                return {
                    my: "left top",
                    at: "left+" + (xPosOfRightEdgeOfMainDiv + GAP_BETWEEN_ELEMENTS)
                        + " top+" + yPosOfTopEdgeOfMainDiv,
                    of: document,
                    collision: "none"
                };
            }

        } else {

            // Popups currently exist
            // Position new popup relative to popup furthest from the top of the page
            // (comparing the top edge of each popup)

            const lastPopup = getPopupFurthestDownThePage();
            if (lastPopup !== undefined) {

                const topOfLastPopup = lastPopup.offset().top;
                const heightOfLastPopup = lastPopup.height();
                const bottomOfLastPopup = topOfLastPopup + heightOfLastPopup;

                if (bottomOfLastPopup + GAP_BETWEEN_ELEMENTS + popupHeight < documentHeight) {

                    if (xPosOfRightEdgeOfMainDiv + GAP_BETWEEN_ELEMENTS + popupWidth + GAP_BETWEEN_ELEMENTS
                        < documentWidth) {

                        // X position: a few pixels to the right of main div
                        // Y position: a few pixels below last popup
                        return {
                            my: "left top",
                            at: "left+" + (xPosOfRightEdgeOfMainDiv + GAP_BETWEEN_ELEMENTS)
                                + " top+" + (bottomOfLastPopup + GAP_BETWEEN_ELEMENTS),
                            of: document,
                            collision: "none"
                        };
                    }

                    // X position: a few pixels from top right of document
                    // Y position: a few pixels below last popup
                    return {
                        my: "right top",
                        at: "right-" + GAP_BETWEEN_ELEMENTS
                            + " top+" + (bottomOfLastPopup + GAP_BETWEEN_ELEMENTS),
                        of: document,
                        collision: "none"
                    };
                }
            } else {
                console.warn("lastPopup is undefined - this should never happen!");
            }
        }

        // Default position if all else fails...

        // X position: a few pixels from top right of document, offset a little for each instance, so they don't exactly overlap
        // Y position: in line with top of main div, offset a little for each instance, so they don't exactly overlap
        return {
            my: "right top",
            at: "right-" + (GAP_BETWEEN_ELEMENTS * (getCount() + 1))
                + " top+" + (yPosOfTopEdgeOfMainDiv + (GAP_BETWEEN_ELEMENTS * (getCount() + 1))),
            of: document,
            collision: "none"
        };

    }

    function getNextToteboardPopupPosition(popupWidth, popupHeight) {

        const preferredPositions = getPopupPositions();

        let preferredPositionToUse;

        if (preferredPositions !== undefined) {
            preferredPositionToUse = getPreferredPositionToUse(preferredPositions);
            if (preferredPositionToUse !== undefined) {

                // Make sure that popup will not be off the right of the page (partially or fully)
                let leftPos = preferredPositionToUse.left;
                if (leftPos + popupWidth > $(window).width()) {
                    leftPos = $(window).width() - popupWidth - GAP_BETWEEN_ELEMENTS;
                }

                return {
                    my: "left top",
                    at: "left+" + leftPos + " top+" + preferredPositionToUse.top,
                    of: document,
                    collision: "none"
                };
            }
        }

        return getDefaultPopupPosition(popupWidth, popupHeight);
    }

    function hidePopups() {
        $.each(popupArray, function (index, popup) {
            if (popup.popup !== undefined) {
                $(popup.popup).closest(".ui-dialog").hide();
            }
        });
    }

    function showPopups() {
        $.each(popupArray, function (index, popup) {
            if (popup.popup !== undefined) {
                $(popup.popup).closest(".ui-dialog").show();
            }
        });
    }

    function makeSurePopupsAreInView() {
        $.each(popupArray, function (index, popup) {
            if (popup.popup !== undefined) {
                const rightEdgeOfPopup = $(popup.popup).offset().left + $(popup.popup).width();
                const windowWidth = $(window).width();

                if (rightEdgeOfPopup > windowWidth) {
                    $(popup.popup).closest(".ui-dialog").css("left", windowWidth - $(popup.popup).width() - GAP_BETWEEN_ELEMENTS);
                }
            }
        });
    }

    function jumpMainContentDivToLeft() {

        $(".draggableMainPanel").css("left", "4px");
        weHaveAlreadyJumpedMainContentDivToLeft = true;
    }

    function openPopup(params) {

        const width = popupPreferredWidth ? popupPreferredWidth : params.defaultWidth;
        const minWidth = params.minWidth;
        const maxWidth = params.maxWidth;
        const height = popupPreferredHeight ? popupPreferredHeight : params.defaultHeight;
        const minHeight = params.minHeight;
        const maxHeight = params.maxHeight;
        const generateToteboardContent = params.generateToteboardContent;
        const onCloseToteboardPopup = params.onCloseToteboardPopup;

        // Remove base tag from document (if still present).
        // It's no longer needed once the site has loaded, and it will interfere with use of jQuery UI tabs,
        $('base').remove();

        // Only jump the main div left when opening popup for first time in this browser session
        if (!weHaveAlreadyJumpedMainContentDivToLeft) {
            jumpMainContentDivToLeft();
        }

        const newToteboardPopup = $("<div id='gep-infoPane'><div id='gep-info-pools' class='gep-infoPools'></div></div>").dialog({
            title: "Toteboard",
            width: width,
            height: height,
            resizable: true,
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight,
            closeOnEscape: true,
            position: getNextToteboardPopupPosition(width, height),
            draggable: true,
            open: function (event) {
                addPopupToArray(this);
                generateToteboardContent($(event.target).find("#gep-info-pools"));
            },
            dragStop: function (event, ui) {
                getPopupPositions();
            },
            resizeStop: function (event, ui) {
                popupPreferredWidth = ui.size.width;
                popupPreferredHeight = ui.size.height;
            },
            close: function () {
                removePopupFromArray(this);
                $(this).dialog('destroy').remove();
                onCloseToteboardPopup();
            }
        });

    }

    return {
        init: init,
        openPopup: openPopup,
        getCount: getCount,
        hidePopups: hidePopups,
        showPopups: showPopups,
        makeSurePopupsAreInView: makeSurePopupsAreInView
    };

}());

function scrollToBottomOfDocument() {
    "use strict";

    $('html,body').animate({ scrollTop: $(document).height() - $(window).height() }, 1000);
}

$(window).resize(function() {
    "use strict";

    toteboardPopups.makeSurePopupsAreInView();
});

function removeQueryStringFromURL() {
    "use strict";

    var url = window.location.href.split('?');
    window.history.replaceState({}, document.title, url[0]);
}

function displayCountdownTime($element, currentValue) {
    "use strict";

    $element.text(`${currentValue} second` + (currentValue === 1 ? "" : "s"));
}

function doCountdown($element, countdownTime) {
    "use strict";

    var countdownInterval;

    displayCountdownTime($element, countdownTime);
    countdownInterval = setInterval(function () {
        countdownTime = countdownTime - 1;
        displayCountdownTime($element, countdownTime);
        if (countdownTime === 0) {
            clearInterval(countdownInterval);
        }
    }, 1000);
}

function displayWaitCountdown(waitTimeInSeconds, messageText) {
    "use strict";

    var pleaseWaitDialog = $(`<div title="&nbsp;" style="padding:10px; border-bottom: solid 1px #ccc;"><p>${messageText.replace("%ESTIMATED_TIME_REMAINING%", "<span id=\"estimatedWaitRemaining\"></span>")}</p></div>`).dialog({
        width: 400,
        height: 'auto',
        modal: true,
        dialogClass: "gep-showRaceOrTrackNotAvailableDialog",
        title: "",
        open: function (event) {
            $(event.target).parent().find(".ui-dialog-titlebar-close").hide();  // hide 'X' icon
            $(event.target).parent().css('position', 'absolute');
            $(event.target).parent().css('top', 200);

            doCountdown($(event.target).find("#estimatedWaitRemaining"), waitTimeInSeconds);

            setTimeout(function () {
                pleaseWaitDialog.dialog("close");
            }, waitTimeInSeconds * 1000);
        },
        close: function () {
            $(this).dialog("destroy");
        }
    });

}


function requestRecaptcha(params, requestLocationOnLogin) {
    "use strict";

    $(`<div title="&nbsp;" style="padding:10px; border-bottom: solid 1px #ccc;"><p>Please check the box below to continue</p><div id="recaptchaDiv"></div></div>`).dialog({
        width: 400,
        height: 'auto',
        modal: true,
        dialogClass: "gep-showRaceOrTrackNotAvailableDialog",
        create: function() {
            // If user hits X to cancel the reCAPTCHA and abort login, clear the password field
            $(this).closest('div.ui-dialog')
                .find('.ui-dialog-titlebar-close')
                .click(function(e) {
                    $("#loginFrame")[0].contentWindow.clearPasswordField();
                    e.preventDefault();
                });
        },
        open: function (event) {
            var theDialog = this;
            var recaptchtaId;

            $(event.target).find(".ui-dialog-titlebar-close").hide();  // hide 'Close' button
            $(event.target).parent().css('position', 'absolute');
            $(event.target).parent().css('top', 200);

            recaptchtaId = grecaptcha.render("recaptchaDiv", {
                "sitekey": serverData.recaptchaSitekey,
                callback: function (reCAPTCHAToken) {
                    grecaptcha.reset(recaptchtaId);
                    $(theDialog).dialog("close");
                    if (params === undefined) {
                        params = {};
                    }
                    params.reCAPTCHAToken = reCAPTCHAToken;
                    $("#loginFrame")[0].contentWindow.doLoginPart3_callEstablishUserSession(params, requestLocationOnLogin);
                }
            });
        },
        close: function () {
            $(this).dialog("destroy");
        }
    });

}

function showLoginPrompt(title, signupMessage, topMessage, onSuccessMethod) {
    "use strict";

    showLoginPromptNewStyle(title, signupMessage, topMessage, onSuccessMethod);
    window.scrollTo(0, 0);

}

function showLoginPromptNewStyle(title, signupMessage, topMessage, onSuccessMethod) {
    "use strict";

    loginFrame = $("#loginFrame")[0].contentWindow;

    const loginOrUpgradeDialog = $(`<div id="loginDialog" title="${title}" style="padding:10px;border-bottom: solid 1px #ccc;" >` +
        `<div style="padding-left: 1em; margin: 12px 0">` + topMessage + `</div>` +
        `<div style="display:flex"><div class="gep-loginCredentialsLabel">Username</div><div><input class="gep-username" /></div></div>` +
        `<div style="display:flex"><div class="gep-loginCredentialsLabel">Password</div><div><input type="password" class="gep-password" /></div></div>` +
        `<div style="display:flex"><div style="width: 7em; padding-left: 1em;"></div><button class="gep-mainButton">LOGIN</button></div>` +
        `<div style="margin: auto; width: 80%; display:flex; padding: 20px 0">` +
        `<div><a class="gep-forgotUsername" href="javascript:void(0)">Forgot Username?</a></div>` +
        `<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>` +
        `<div><a class="gep-forgotPassword" href="javascript:void(0)">Forgot Password?</a></div>` +
        `</div>` +
        `</div>`).dialog({
        width: 340,
        modal: true,
        draggable: false,
        close: function () {
            unmaskHeader();
            loginOrUpgradeDialog.dialog("destroy");
            toteboardPopups.showPopups();
        },
        position: {
            my: "center",
            at: "center top",
            of: window
        },
        open: function (event) {
            $(event.target).parent().css('top', 250);
            $(event.target).focus();
            $(event.target).find(".gep-forgotUsername").click(function () {
                hidePromoCarousel();
                loginFrame.changeFragmentId("");
                loginFrame.call("showForgotUsername");
                loginOrUpgradeDialog.dialog("close");
            });
            $(event.target).find(".gep-forgotPassword").click(function () {
                hidePromoCarousel();
                loginFrame.changeFragmentId("");
                loginFrame.call("showForgotPassword");
                loginOrUpgradeDialog.dialog("close");
            });
            $(".gep-modalDialogNewStyle").append(`<div style="position:absolute; top:24px; left:130px;">${signupMessage}</div>`);
            $(".gep-modalDialogNewStyle .gep-join").bind("click", function () {
                loginOrUpgradeDialog.dialog("close");
                loginFrame.routeChanged("register");
            });
        },
        dialogClass: 'gep-modalDialogNewStyle',
        create: function () {
            // Hack to make sure hitting ENTER key in IE won't close the dialog
            $("button.ui-dialog-titlebar-close", this.parent).attr("type", "button");
        }
    });


    // Submit login form if user presses ENTER key
    loginOrUpgradeDialog.keyup(function (e) {
        if (e.keyCode === $.ui.keyCode.ENTER) {
            loginOrUpgradeDialog.find("button.gep-mainButton").eq(0).trigger("click");
        }
    });

    $(".gep-mainButton", loginOrUpgradeDialog).bind("click", function () {
        loginOrUpgradeDialog.dialog("close");
        loginFrame.doLogin({
            username: $(".gep-username", loginOrUpgradeDialog).val(),
            password: $(".gep-password", loginOrUpgradeDialog).val(),
            onSuccess: function () {
                loginFrame.logonToPushIfPushEnabled();
                if (onSuccessMethod) {
                    onSuccessMethod();
                }
            }
        });
    });

    $(".gep-upgrade", loginOrUpgradeDialog).bind("click", function () {
        loginOrUpgradeDialog.dialog("close");
        loginFrame.call("showUpgradeUserProfile");
    });
}

// This function must be present as commonSiteModule calls it
function onResizeBrowser() {
    "use strict";

    // do nothing
}

function promptForTwoFactorAuthenticationCode(
    twoFactorAuthenticationMode,
    twoFactorAuthenticationSessionId,
    displayCodeIncorrectMessage,
    displayCantResendCodeMessage,
    twoFactorAuthenticationCode,
    isToBeAddedAsTrustedDevice,
    deviceName,
    twoFactorAuthResendWaitingPeriodEmail,
    twoFactorAuthResendWaitingPeriodSMS,
    onSubmitCode
) {
    "use strict";

    let twoFactorAuthPopUp;

    // commonSiteModule assumes GEC instance is named "myGEC"
    myGEC = $("#loginFrame")[0].contentWindow.getGEC();

    function handleMessageFromCommonSite(event) {

        if (!commonSiteModule.isMessageFromTrustedHost(event.origin)) {
            console.warn("Message " + event.data.message + " received from " + event.origin + " is not from the expected origin and will be ignored. Check Web.config is correct.");
            return;
        }

        commonSiteModule.handleStandardEventsFromCommonSite(event, 250);

        switch (event.data.message) {
            case "readyToHandleMessages":
                commonSiteModule.postMessageToCommonSite({
                    message: 'loadTwoFactorAuthenticationCheck',
                    twoFactorAuthenticationMode: twoFactorAuthenticationMode,
                    isMobileSite: false,
                    displayCodeIncorrectMessage: displayCodeIncorrectMessage,
                    displayCantResendCodeMessage: displayCantResendCodeMessage,
                    twoFactorAuthenticationCode: twoFactorAuthenticationCode,
                    isToBeAddedAsTrustedDevice: isToBeAddedAsTrustedDevice,
                    deviceName: deviceName,
                    emailResendWaitPeriodInSeconds: twoFactorAuthResendWaitingPeriodEmail,
                    smsResendWaitPeriodInSeconds: twoFactorAuthResendWaitingPeriodSMS
                }, "*");
                break;
            case "componentHasRendered":
                break;
            case "twoFactorAuthenticationCodeSubmittedByUser":
                twoFactorAuthPopUp.dialog("close");
                onSubmitCode(
                    event.data.twoFactorAuthenticationCode,
                    event.data.twoFactorAuthenticationMode,
                    event.data.isToBeAddedAsTrustedDevice,
                    event.data.deviceName
                );
                break;
            case 'resendCode':
                twoFactorAuthPopUp.dialog("close");
                onSubmitCode(
                    undefined,
                    event.data.twoFactorAuthenticationMode,
                    false,
                    ""
                );
                break;

        }
    }

    commonSiteModule.setHandlerForMessagesFromCommonSite(handleMessageFromCommonSite);

    twoFactorAuthPopUp = $(`<div class="gep-dialog"><iframe id="commonSiteIframe" src="${serverData.commonSiteHost + serverData.commonSitePath}?site=desktop" width="100%" height="300" frameborder="0" scrolling="no"/></div>`).dialog({
        modal: true,
        width: 400,
        resizable: false,
        dialogClass: 'gep-modalDialogNewStyle gep-dialogWithNoTitleBar',
        closeOnEscape: false,
        position: {
            my: "center",
            at: "center center",
            of: window
        },
        open: function (event) {
            //$(".ui-dialog-titlebar-close").hide();
            $(event.target).parent().css('top', 250);
            $(event.target).focus();
        },
        close: function () {
            $(this).dialog("destroy").remove();
        }
    });
}

/* Show the specified text in a simple modal dialog with a CLOSE button.
 * The text may optionally contain one hyperlink, in which case a function
 * to be called on click of the link must be passed in. */
function showModalDialog(dialogText, onClickLinkInText) {
    "use strict";

    maskHeader();

    const modalDialog = $(`<div id="loginDialog" title="&nbsp;" style="padding:10px;border-bottom: solid 1px #ccc;" >` +
        `<div style="padding-left: 1em; margin: 12px 0">${dialogText}</div>` +
        `<button class="gep-mainButton" style="float: right; margin: 10px;">OK</button>` +
        `</div>`
    ).dialog({
        width: 340,
        height: 'auto',
        modal: true,
        dialogClass: 'gep-modalDialogNewStyle',
        autoOpen: false,
        open: function (event) {
            $(event.target).parent().css('top', 250);
            $(event.target).find("button").blur();
            $(event.target).find("a").first().blur().click(function () {
                $(event.target).dialog("close");
                onClickLinkInText();
            });
        },
        close: function () {
            unmaskHeader();
            $(this).dialog("destroy");
        }
    });

    $(".gep-mainButton", modalDialog).bind("click", function () {
        modalDialog.dialog("close");
    });

    modalDialog.parent().css({ position: "fixed" }).end().dialog('open');
}
